import { getPricesForUpsellAddonProducts } from "../getAddonProductPrice/getPricesForUpsellAddonProducts";

const isDevelopment = process.env.NODE_ENV === "development";

export const getUpsellProductsAndAddonPrices =
  (hostingPackageId, itemsInCart) =>
  async (dispatch, getState, { api }) => {
    let upsellProducts = [];
    let addons = [];
    let plans = [];
    let highlightedUpsell = null;

    try {
      const response = await api.getUpsellProducts(
        hostingPackageId,
        itemsInCart,
      );

      if (response && response.result) {
        const { result } = response;
        plans = result.plans;
        addons = result.addOnProducts;
        highlightedUpsell = result.preferred;

        // We don't want to upsell the same plan that is already in the cart
        upsellProducts = upsellProducts.concat(plans, addons);
      }
    } catch (err) {
      console.error("Get upsell packages failed", err);
    }

    if (upsellProducts.length === 0 && isDevelopment) {
      console.warn(
        [
          `WARNING: No upsell products returned."!`,
          "(This warning is only shown in development, not in production)",
        ].join(" "),
      );
    }

    // For each product we want to show as upsell, fetch the price
    const addonProductPrices = await dispatch(
      getPricesForUpsellAddonProducts(addons),
    );

    return { upsellProducts, addonProductPrices, highlightedUpsell };
  };
